<template>
  <div style="display: flex; align-items: center">
    <svg
      v-if="name === 'copyIcon'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.25 1C2.85217 1 2.47064 1.15804 2.18934 1.43934C1.90804 1.72064 1.75 2.10217 1.75 2.5V8.5C1.75 8.8978 1.90804 9.27935 2.18934 9.56065C2.47064 9.84195 2.85217 10 3.25 10H3.75V10.5C3.75 11.3285 4.42158 12 5.25 12H9.25C10.0785 12 10.75 11.3285 10.75 10.5V4.5C10.75 3.67158 10.0785 3 9.25 3H8.75V2.5C8.75 2.10217 8.59195 1.72064 8.31065 1.43934C8.02935 1.15804 7.6478 1 7.25 1H3.25ZM7.75 3V2.5C7.75 2.36739 7.6973 2.24022 7.60355 2.14645C7.5098 2.05268 7.3826 2 7.25 2H3.25C3.11739 2 2.99022 2.05268 2.89645 2.14645C2.80268 2.24022 2.75 2.36739 2.75 2.5V8.5C2.75 8.6326 2.80268 8.7598 2.89645 8.85355C2.99022 8.9473 3.11739 9 3.25 9H3.75V4.5C3.75 3.67158 4.42158 3 5.25 3H7.75ZM4.75 10.5C4.75 10.7761 4.97386 11 5.25 11H9.25C9.52615 11 9.75 10.7761 9.75 10.5V4.5C9.75 4.22386 9.52615 4 9.25 4H5.25C4.97386 4 4.75 4.22386 4.75 4.5V10.5Z"
        fill="#87909F"
      />
    </svg>
    <svg
      v-if="name === 'editpen'"
      width="14"
      height="14"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42430_43803)">
        <path
          d="M5.10581 13.9099H1.63672V10.4163L10.9967 1.05628C11.15 0.903894 11.3574 0.818359 11.5735 0.818359C11.7897 0.818359 11.9971 0.903894 12.1504 1.05628L14.4658 3.37174C14.5416 3.44819 14.6016 3.53885 14.6423 3.63854C14.6831 3.73822 14.7037 3.84497 14.7031 3.95264C14.7037 4.06032 14.6831 4.16706 14.6423 4.26675C14.6016 4.36644 14.5416 4.4571 14.4658 4.53355L5.10581 13.9099ZM1.63672 15.5463H16.364V17.1826H1.63672V15.5463Z"
          fill="#0D0E0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_42430_43803">
          <rect
            width="14.7273"
            height="16.3391"
            fill="white"
            transform="translate(1.63672 0.818359)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "publicIcons",
  props: {
    name: {
      type: String,
      required: true,
    },
    graywidth: {
      type: String,
    },
  },
};
</script>
<style lang="less" scoped></style>
